<template>
  <div class="top">
    <myTools></myTools>

    <div style="width: 180px; height: 100%; display: flex; align-items: center;">
      <img src="@/assets/img/logo.png" alt="考试云" style="width: 155px; height: 40px" @click="goIndex">
    </div>

    <el-menu ref="elMenu" mode="horizontal" @select="handleSelect">
      <el-menu-item index="exam">我的考试</el-menu-item>
      <el-menu-item v-if="$store.state.roleType === 'admin'" index="examCreate">创建考试</el-menu-item>
      <el-menu-item v-if="$store.state.roleType === 'admin'" index="examPaper">试卷库</el-menu-item>
      <el-menu-item v-if="$store.state.roleType === 'admin'" index="questions">试题库</el-menu-item>
      <el-menu-item v-if="'0,1'.indexOf($store.state.user.jslx) !== -1" index="user">考生管理</el-menu-item>
      <el-menu-item index="help">
        <i class="el-icon-help"/>
        <span style="font-size: 20px;color: blue;" >帮助手册</span>
      </el-menu-item>
    </el-menu>

    <div style="margin-left: auto; height: 100%; display: flex; align-items: center;">
      <a href="javascript: void(0);" @click="toExaminee()" style="font-size: 16px;color: blue; text-decoration: underline !important;">进入考生平台</a>
      <div style="width: 15px;"></div>
      <el-image :src="userHead" style="width: 25px; height: 25px"></el-image>
      <div style="width: 5px;"></div>
      <label>{{yhmc}}</label>
      <div style="margin: 0 5px;">|</div>
      <span  @click="loginOut"  style="font-size: 16px;cursor: pointer;">
          退出登录
      </span>
    </div>

    <!-- <el-row style="padding-left: 180px">
      <el-col :span=17>
      </el-col>
      <el-col :span=7 class="rightHeader" style="font-size: 16px;">
        <a href="javascript: void(0);" @click="toExaminee()" style="color: blue; font-size: 13px; text-decoration: underline !important; margin-right: 10px;">
          <span>进入考生平台</span>
        </a>
        <div style="display: inline-flex;">
          <el-image :src="userHead" style="width: 25px; height: 25px"></el-image>
        </div>
        <label>{{yhmc}}</label>
        <span>|</span>
        <span>
          <a href="javascript:void(0)" @click="loginOut">退出登录</a>
        </span>
      </el-col>
    </el-row> -->
  </div>
</template>
<script>
import myTools from '@/components/myTools'
import { toMyExam } from '@/api/examinee'
import { loginOut } from '@/api/baseApi'
export default {
  data () {
    return {
      yhmc: '',
      userHead: require('@/assets/img/defaultUserhead.png'),
      activeIndex: null
    }
  },
  components: {
    myTools
  },
  methods: {
    setActiveIndex () {
      // 设置导航栏部分
      const url = this.$route.path
      if (RegExp(/^\/exam\/add[\s\S]*$/).test(url) || RegExp(/^\/exam\/edit[\s\S]*$/).test(url) || RegExp(/^\/exam\/setting[\s\S]*$/).test(url)) {
        this.activeIndex = 'examCreate'
      } else if (RegExp(/^\/examPaper\/add[\s\S]*$/).test(url) || RegExp(/^\/examPaper\/edit[\s\S]*$/).test(url)) {
        this.activeIndex = 'examCreate'
      } else if (RegExp(/^\/examPaper[\s\S]*$/).test(url)) {
        this.activeIndex = 'examPaper'
      } else if (RegExp(/^\/questions[\s\S]*$/).test(url)) {
        this.activeIndex = 'questions'
      } else if (RegExp(/^\/exam[\s\S]*$/).test(url)) {
        this.activeIndex = 'exam'
      } else if (RegExp(/^\/user[\s\S]*$/).test(url)) {
        this.activeIndex = 'user'
      } else if (url === '/') {
        this.activeIndex = 'exam'
      }
      if (this.activeIndex) {
        // 更新默认导航栏
        this.$store.commit('changeDefaultActiveIndex', this.activeIndex)
      } else {
        // 选中上一次的那个导航栏
        const defaultActiveIndex = this.$store.state.defaultActiveIndex
        if (defaultActiveIndex) {
          this.activeIndex = defaultActiveIndex
        } else {
          this.activeIndex = 'exam'
        }
      }
      this.$refs.elMenu.activeIndex = this.activeIndex
    },
    handleSelect (index) {
      // 还原选中状态
      this.$refs.elMenu.activeIndex = this.activeIndex
      // 更新默认导航栏
      this.$store.commit('changeDefaultActiveIndex', index)
      if (index === 'exam') {
        this.$router.push({
          path: '/exam/list'
        })
      } else if (index === 'examCreate') {
        this.$router.push({
          path: '/exam/add'
        })
      } else if (index === 'examPaper') {
        this.$router.push({
          path: '/examPaper/list'
        })
      } else if (index === 'questions') {
        this.$router.push({
          path: '/questions/list'
        })
      } else if (index === 'user') {
        this.$router.push({
          path: '/user/list'
        })
      } else if (index === 'help') {
        const helpHtml = this.$router.resolve({
          path: '/help/'
        })
        window.open(helpHtml.href, '_blank')
        this.setActiveIndex()
      }
    },
    goIndex () {
      this.$router.push({
        path: '/'
      })
    },
    loginOut () {
      loginOut().then(res => {
        this.$http.callback(res, () => {
          this.$router.push({
            path: '/login'
          })
        })
      })
    },
    toExaminee () {
      toMyExam(null).then(res => {
        this.$http.callback(res, () => {
          this.$store.commit('mobile/setUser', res.data.user)
          this.$store.commit('mobile/setToken', res.data.token)
          this.$store.commit('mobile/setAuth', res.data.auth)
          this.$router.push({
            path: '/examinee/list'
          })
        })
      })
    }
  },
  mounted () {
    this.setActiveIndex()
    // 设置用户信息部分
    const user = this.$store.state.user
    if (user !== null) {
      this.yhmc = user.yhmc
      if (user.txdz) {
        this.userHead = user.txdz
      }
    }
  }
}
</script>
<style scoped>
  /* 修改导航栏样式 start */
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 5px solid #409EFF;
    color: #409EFF;
  }
  .el-menu--horizontal>.el-menu-item {
    color: black;
    font-size: 20px;
  }
  a {
    text-decoration: none;
    color: black;
  }
  #sysLogo:hover {
    cursor: pointer;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }
  .el-menu-item {
    font-weight: bold;
  }
  /* 修改导航栏样式 end */
  .top {
    height: 60px;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    background-color: #fff;
    padding: 0 1.5rem;
    width: 100%;
    /* box-sizing: border-box; */
    position: fixed;
    top: 0;
    z-index: 9;
  }
  .rightHeader {
    font-size: 18px;
    text-align: right;
    margin: 15px 0;
    display: inline-block;
    height: 30px;
    line-height: 30px
  }
  .rightHeader>span {
    margin : 3px;
  }
</style>
